import React, { useEffect, useState } from "react";

/**
 * ScrollProgressBar — fixed top progress line that fills as user scrolls.
 */
const ScrollProgressBar = () => {
  const [progress, setProgress] = useState(0);

  useEffect(() => {
    const onScroll = () => {
      const total = document.documentElement.scrollHeight - window.innerHeight;
      if (total <= 0) {
        setProgress(0);
        return;
      }
      const p = Math.min(100, Math.max(0, (window.scrollY / total) * 100));
      setProgress(p);
    };
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <div
      data-testid="scroll-progress-bar"
      className="scroll-progress"
      style={{ width: `${progress}%` }}
    />
  );
};

export default ScrollProgressBar;
